import React, { useCallback, useEffect, useState } from 'react';
import ConfigFolderEdit from './ConfigFolderEdit';
import ConfigFolderLabel from './ConfigFolderLabel';
import { K_INFO } from '../../../providers/ConfigsDataContextProvider';
import './ConfigFolderCtrl.css';

const ConfigFolderCtrl = ({ parentFolderPath, parentFolder, folderName, withError }) => {
  const [editMode, setEditMode] = useState(false);
  const [locked, setLocked]     = useState(false);
  const [justCreated, setJustCreated] = useState(false);
  // const {tagFolderLocked, clearFolderLocked}= useFolderListenerContext();  
  const [errInfo, setErrInfo] = useState(withError);

  //------ Switch to EditMode (unless locked)
  //
  const switchToEditMode = useCallback(() => {
    if (!locked) {
      setEditMode(true);
    }
    else {
      // indication of a locked click...
      console.log('Key LOCKED');
    }
  }, [locked]);

  //------ Switch To Label Mode
  //
  const switchToLabelMode = useCallback(()=>{
    setEditMode(false);
  },[]);

  //------  Effect kInfo  ------
  //
  useEffect(()=>{
    if (parentFolder) {
      if (parentFolder[folderName]) {
        const kInfo = parentFolder[folderName][K_INFO];
        if (Boolean(kInfo.folderEdit) || Boolean(withError)) {
          switchToEditMode();
        }
        setErrInfo(withError);
        setLocked(kInfo.folderLocked);
        setJustCreated(kInfo.folderJustCreated);
      }
    }         
  }, [parentFolder, folderName, switchToEditMode, withError]);


  //------  Lock Me ------
  //
  const lockMe = useCallback((e) =>{
    // TODO: if locked, do not allow delete nor rename
    //       to prevent entering the folder by click, we need a new feature like "No-Entry".
    e.preventDefault();
    // clearFolderLocked(parentFolderPath, folderName)
    //   .then(setLocked(false));
  }, []);


  return (
    <div className='configFolderCtrl' onContextMenuCapture={lockMe}>
      {editMode && <ConfigFolderEdit parentFolderPath={parentFolderPath} parentFolder={parentFolder} folderName={folderName} switchToLabel={switchToLabelMode} withError={errInfo}/>}
      {!editMode && <ConfigFolderLabel parentFolderPath={parentFolderPath} folderName={folderName} switchToEdit={switchToEditMode}/>}
    </div>
  );
};

export default ConfigFolderCtrl;